// src/config.js
// Exports configuration variables for the frontend application

// Access environment variables defined in .env (prefixed with REACT_APP_ for Create React App)
const REACT_APP_WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const REACT_APP_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const REACT_APP_MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN; // FIXED NAME

// --- Define Fallback Values (used if environment variables are not set) ---
const FALLBACK_WEBSOCKET_URL = 'ws://flowsense.live:3001'; 
const FALLBACK_API_BASE_URL = 'http://flowsense.live:3001/api/v1'; 
const FALLBACK_GOOGLE_MAPS_KEY = ''; 
const FALLBACK_MAPBOX_TOKEN = ''; 

// --- Basic Validation and Logging for Missing Environment Variables ---
if (!REACT_APP_WEBSOCKET_URL) {
  console.warn(`Warning: REACT_APP_WEBSOCKET_URL is not defined in your .env file. Falling back to: ${FALLBACK_WEBSOCKET_URL}`);
}
if (!REACT_APP_API_BASE_URL) {
  console.warn(`Warning: REACT_APP_API_BASE_URL is not defined in your .env file. Falling back to: ${FALLBACK_API_BASE_URL}`);
}
if (!REACT_APP_GOOGLE_MAPS_API_KEY) {
  console.warn("Warning: REACT_APP_GOOGLE_MAPS_API_KEY is not defined in your .env file. Map features may not work as expected.");
}
if (!REACT_APP_MAPBOX_ACCESS_TOKEN) { // UN-NESTED THIS BLOCK
  console.error("❌ ERROR: REACT_APP_MAPBOX_ACCESS_TOKEN is missing — Mapbox map will not load!");
}

// --- Export Configuration Object ---
export const config = {
  // If REACT_APP_WEBSOCKET_URL isn't found, default to relative /ws/ path
  websocketUrl: REACT_APP_WEBSOCKET_URL || `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws/`,
  
  // If REACT_APP_API_BASE_URL isn't found, default to relative /api/v1 path
  apiUrl: REACT_APP_API_BASE_URL || '/api/v1',
  googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY || FALLBACK_GOOGLE_MAPS_KEY,
  mapboxToken: REACT_APP_MAPBOX_ACCESS_TOKEN || FALLBACK_MAPBOX_TOKEN, // FIXED NAME
  appName: "FlowSense MOW+" 
};

// Log the final effective configuration
if (process.env.NODE_ENV === 'development') {
    console.log("Frontend Config Loaded (Development):", {
        websocketUrl: config.websocketUrl,
        apiUrl: config.apiUrl,
        googleMapsApiKey: config.googleMapsApiKey ? '*** KEY LOADED ***' : '!!! GOOGLE MAPS API KEY MISSING !!!',
        mapboxToken: config.mapboxToken ? '** Loaded **' : '❌ Missing',
        appName: config.appName
    });
}